<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="800">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-snackbar :style="{ marginTop: snack_height + 'px' }" v-model="tbsnackbar" :top="true" color="error">
            <span class="tab-msg">Tab Switching Not Allowed!!</span>
            <v-btn class="tab-msg" dark text @click="tbsnackbar = false">Close</v-btn>
        </v-snackbar>
        <v-dialog transition="dialog-top-transition" max-width="400" v-model="tb">
            <template>
                <v-card>
                    <v-card-text>
                        <center>
                            <div class="text-h2 pa-12" style="font-weight: bold; font-size: 20px; color: red;">
                                Are you sure!!!
                            </div>
                            <v-row class="justify-center">
                                <v-btn style="margin: 10px;" color="error" @click="yes">YES</v-btn>
                                <v-btn style="margin: 10px;" color="success" @click="no">NO</v-btn>
                            </v-row>
                        </center>
                    </v-card-text>
                </v-card>
            </template>
        </v-dialog>
        <div class="main-h">
            <div class="mt-4">
                <router-link :to="'/home-new'" style="text-decoration: none;" class="root">
                    <v-icon left class="home-icon">mdi-keyboard-backspace</v-icon>
                    <span class="home-text">Home</span>
                </router-link>
            </div>
            <template v-if="deviceWidth > 600">
                <div class="mt-4 borderes" v-if="show_whitebord == true">
                    <a href="https://jamboard.google.com/" target="popup" class="whiteboard" onclick="window.open('https://jamboard.google.com/','popup','width=600,height=600,scrollbars=no,resizable=no'); return false;">
                        White Board
                    </a>
                </div>

                <div class="mt-4 borderes">
                    <v-icon left color="#ff9800">mdi-book-open-page-variant</v-icon>
                    <span> Mock Test </span>
                </div>

                <div class="mt-4" style="display: flex;">
                    <div class="timer"><v-icon color="red" left>mdi-timer-sand</v-icon>Remaining Time : {{ show_time }}</div>
                    <div>
                        <v-btn rounded small @click="exitExam('ask')" class="end-exam"> <v-icon left>mdi-stop-circle-outline</v-icon> End Exam </v-btn>
                    </div>
                </div>
            </template>
        </div>
        <br />
        <br />
        <br />
        <!-- {{ que_list[que_index] }} -->
        <template v-if="deviceWidth < 600">
            <div class="mt-4 timer-m">
                <div class="timer"><v-icon color="red" left>mdi-timer-sand</v-icon> {{ show_time }}</div>
                <div>
                    <v-btn rounded small @click="exitExam('ask')" class="end-exam"> <v-icon left>mdi-stop-circle-outline</v-icon> End Exam </v-btn>
                </div>
            </div>
            <v-row class="justify-center">
                <div class="mt-4 borderes">
                    <v-icon left color="#ff9800" class="pl-2">mdi-book-open-page-variant</v-icon>
                    <span>Dummy Course1</span>
                </div>
            </v-row>
        </template>
        <template v-if="que_list != null">
            <v-row class="row-card">
                <v-col xs="12" sm="12" lg="9" xl="9" md="12" cols="12">
                    <v-card class="card-ques" id="style-3" :style="{ height: deviceHeight + 'px' }">
                        <div class="d-f que-display">
                            <div>
                                <span class="que-tag">Question - {{ que_index + 1 }}/{{ que_list.length }}</span>
                            </div>
                            <div>
                                <span class="time que-tag">[ {{ 2 }} mark ]</span>
                            </div>
                        </div>

                        <div class="que main-copy">
                            <div class="question-block">
                                <span class="question-text" v-html="que_list[que_index].question"></span>
                                <span v-if="que_list[que_index].question_image != null">
                                    <img class="imgs-question" :src="que_list[que_index].question_image" v-if="que_list[que_index].question_image != null" @click="zooimg(que_list[que_index].question_image)" />
                                    <!-- <img :src="current_ques.question_image" v-if="current_ques.question_image!=null" class="q-img" /> -->
                                </span>
                            </div>
                            <!-- MCQ -->
                            <template>
                                <b class="options-text">Options</b>
                                <v-card-text class="padding-options">
                                    <br />
                                    <div v-for="opt in que_list[que_index].options" :key="opt.id">
                                        <div class="row padding-zero">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 padding-top-zero">
                                                <div class="row padding-zero">
                                                    <div class="opt" @click="check(opt.option_name)">
                                                        <div class="opt-label">{{ opt.option_name }}</div>
                                                    </div>
                                                    <div class="opt-radio">
                                                        <div class="opt-label">
                                                            <input
                                                                type="radio"
                                                                :id="opt.option_name"
                                                                @click="select_opt = opt"
                                                                v-if="
                                  que_list[que_index].selectedoption_obj != null
                                "
                                                                :name="que_list[que_index].id"
                                                                :checked="
                                  que_list[que_index].selectedoption_obj.id ==
                                  opt.id
                                "
                                                            />
                                                            <input type="radio" :id="opt.option_name" @click="select_opt = opt" v-else :name="que_list[que_index].id" />
                                                        </div>
                                                    </div>
                                                    <span class="option-val" v-html="opt.option_value"></span>
                                                    <!-- <img class="imgs-options" :src="opt.option_file" v-if="opt.option_file!=null" @click="zooimg(opt.option_file)" /> -->
                                                    <!-- <img :src="opt.option_file" v-if="opt.option_file!=null" class="ans-img" /> -->
                                                </div>
                                                <div>
                                                    <img class="imgs-options" :src="opt.option_file" v-if="opt.option_file != null" @click="zooimg(opt.option_file)" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </v-card-text>
                                <br />
                            </template>
                        </div>
                    </v-card>

                    <div class="nav-btn">
                        <v-btn class="sub-btn next-btn" rounded :loading="save_load_btn" @click="getPrevious" v-if="que_index !== 0">Previous</v-btn>
                        <v-btn :loading="save_load_btn" rounded class="sub-btn save-btn" @click="saveAnswer(que_index,select_opt)">Save</v-btn>&nbsp;&nbsp;
                        <!-- <v-btn
              :loading="save_load_btn"
              rounded
              class="sub-btn review-btn"
              @click="saveAnswer('REVIEW')"
              >Save & Review</v-btn
            >
            &nbsp;&nbsp; -->
                        <v-btn class="sub-btn next-btn" rounded :loading="save_load_btn" @click="getNext" v-if="!(que_index == que_list.length - 1)">Next</v-btn>
                    </div>
                </v-col>

                <v-col xs="12" sm="12" lg="3" xl="3" md="12" cols="12" class="overview-row">
                    <v-card class="overview-card" :style="{ height: deviceHeight + 'px' }">
                        <div class="que-display">
                            <span class="que-tag">Questions Overview</span>
                        </div>
                        <v-card-text align="center">
                            <v-btn
                                :loading="save_load_btn"
                                rounded
                                @click="getQues(ques, index)"
                                :style="{
                                    'background-color': ques.selectedoption_obj.id != null ? 'rgb(51, 255, 68)' : 'rgb(231, 76, 60)',
                                    margin: '3px',
                                    color: 'white',
                                    'font-size': que_index !== index ? '' : '20px',
                                    border: que_index !== index ? 'none' : '3px solid black',
                                    color: que_index !== index ? 'white' : 'black',
                                }"
                                v-for="(ques, index) in que_list"
                                :key="ques.id"
                            >
                                {{ index + 1 }}
                            </v-btn>
                            &nbsp;
                        </v-card-text>
                          <div style="margin-left: 2rem">
              <v-card-text
               
                class="padding-zero"
                style="display: flex; margin-left: 20px"
              >
              
                <div
                  class="status"
                  style=" background-color:rgb(51, 255, 68)"
                  
                ></div>
                <div>
                  <div style="padding: 8px; font-weight: bold">
                    ANSWERED 
                  </div>
                </div>
                
              </v-card-text>
              <v-card-text>
                   <div
                  class="status ml-1"
                  style=" background-color: rgb(231, 76, 60) "
                  
                ></div>
                <div>
                  <div style="margin-top: -25px;
    margin-left: 34px;font-weight: bold">
                   NOT ANSWERED 
                  </div>
                </div>
              </v-card-text>
              <!-- {{supervisionlink}} -->
            </div>
                    </v-card>
                </v-col>
            </v-row>
        </template>
        <v-row justify="center">
            <v-dialog v-model="dialog_zooimg" persistent max-width="800px">
                <v-card>
                    <br />
                    <v-card-title>
                        <span class="headline">Image Pre-View</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <img class="question-img rounded w-100 d-block imgs-preview" :src="img_url" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" rounded @click="dialog_zooimg = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    import { VueMathjax } from "vue-mathjax";
    import MathLive from "mathlive";
    import Template from "../COE/Template/Template.vue";

    export default {
        components: {
            "vue-mathjax": VueMathjax,
        },
        data() {
            return {
                logoUrl: "https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/vu_logo.jpeg",
                snackbar_msg: "",
                snackbar: false,
                color: "",
                org: null,
                que_list: [],
                tb: false,
                endexamflag_new: false,
                TAB_SWITCHING: null,
                logs: false,
                ISA_table: false,
                deviceWidth: "",
                msg1: "Nothing..",
                chatIcon: true,
                chatFlag: false,
                meetingLink: "",
                meetingBox: false,
                deviceHeight: "",
                tbsnackbar: false,
                tabSwitchCount: 0,
                endexamflag: false,
                supervisionlink: null,
                timeout: 0,
                msg: "",
                dialog: false,
                img_url: "",
                dialog_zooimg: false,
                snackbar_msg: "",
                snackbar: false,
                color: "",
                org: null,
                twominute: true,
                snack_height: "",
                //
                stud_ques_ans_list: null,
                current_ques: null,
                les: null,
                ans_status: null,
                name: "Timer",
                select_opt: null,
                que_index: 0,
                checkbox: null,
                //
                save_load_btn: false,

                //NDV Changes
                totalsec: 300,
                show_time: "",
                user: null,
                tim: null,
                chat_data: null,
                flag: false,
                logWidth: "",
                show_whitebord: false,
                invalidQuestionCheck: null,
                isBlurred: false,
            };
        },
        watch: {
            tabSwitchCount() {
                const data = {
                    les_id: this.les.les_id,
                };
                if (this.TAB_SWITCHING == "NO") {
                    axios
                        .post("/student/updateTabSwitch", data)
                        .then((res) => {
                            if (res.data.status == "YES") {
                                //4CAF50
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        })
                        .finally(() => {});
                }
            },
        },
        mounted() {
            this.onLoad();
            this.deviceWidth = window.innerWidth;
            this.deviceHeight = window.innerHeight - 160;
            this.snack_height = this.deviceHeight / 2;
            this.totalsec = 600;
            this.user = localStorage.getItem('EPS-uid');
            if (this.totalsec > 0) {
                this.tim = setInterval(() => {
                    this.showtime();
                }, 1000);
            }

            if (this.deviceWidth > 600) {
                this.logWidth = "1000";
            }
            if (this.deviceWidth < 600) {
                this.logWidth = "1000";
            }
             this.ans_status = JSON.parse(localStorage.getItem("ans_status"));

            // document.addEventListener("contextmenu", (event) => event.preventDefault());
        },
        methods: {
            saveAnswer(que_index, selected_otp) {
                if (this.select_opt == null) {
                    this.showSnackbar("#b71c1c", "Please select option.");
                    return;
                }
                this.que_list[que_index].selectedoption_obj.id = selected_otp.id;
                this.que_list[que_index].selectedoption_obj.option_name = selected_otp.option_name;
                this.que_list[que_index].selectedoption_obj.option_value = selected_otp.option_value;
              // alert("Answer submitted successfully...")
               
                this.showSnackbar("green", "Answer submitted successfully...");
                // this.$swal("", "Answer submitted successfully...", "success");
                this.que_index++;
                console.log(this.que_list[que_index]);
                this.select_opt = null;
                
                
            },
            yes() {
                 this.$router.push({
          name: "mock-stud-end-exam",
        });
                //   this.tb = false;
                //   this.endexamflag_new = true;
                //   var all_ques = [];
                //   for (var i = 0; i < this.stud_ques_ans_list.length; i++) {
                //     all_ques.push(this.stud_ques_ans_list[i].id);
                //   }
                //   const formData = {
                //     les_id: this.les.les_id,
                //     all_ques: all_ques,
                //   };
                //   if (this.endexamflag_new) {
                //     axios
                //       .post("/student/endExam", formData)
                //       .then((res) => {
                //         if (res.data.status == "YES") {
                //           //4CAF50
                //         }
                //       })
                //       .catch((error) => {
                //         this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                //       })
                //       .finally(() => {});
                //     this.twominute = false;
                //     //window.alert(this.flag)
                //     if (this.flag == true) {
                //       this.$router.push({
                //         name: "show-result",
                //       });
                //     } else {
                //       this.$router.push({
                //         name: "stud-end-exam",
                //       });
                //     }
                //   }
            },
            no() {
                this.tb = false;
                this.endexamflag_new = false;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            sformat(s) {
                var fm = [
                    // Math.floor(Math.floor(Math.floor(s / 60) / 60) / 24) % 24, //DAYS
                    Math.floor(Math.floor(s / 60) / 60) % 60, //HOURS
                    Math.floor(s / 60) % 60, //MINUTES
                    s % 60, //SECONDS
                ];
                return $.map(fm, function (v, i) {
                    return (v < 10 ? "0" : "") + v;
                }).join(":");
            },
            showtime() {
                //console.log("showtime");
                // 1 seconde eraf
                this.totalsec--;
                this.show_time = this.sformat(this.totalsec);
                if (this.totalsec == 0) {
                    clearInterval(this.tim);
                    //console.log("Exam ended...")
                    this.exitExam("");
                }
            },
            exitExam(check) {
                // this.dialog = true;
                this.tb = true;
            },
            getQues(ques, index) {
                this.current_ques = ques;
                this.que_index = index;
                this.select_opt = this.current_ques.selectedoption_obj;
            },
            saveSubj(type) {},
            getNext() {
                // this.que_index = this.que_index+1
                this.current_ques = this.stud_ques_ans_list[++this.que_index];
                this.select_opt = this.current_ques.selectedoption_obj;
            },
            getPrevious() {
                this.current_ques = this.stud_ques_ans_list[--this.que_index];
                this.select_opt = this.current_ques.selectedoption_obj;
            },
            zooimg(url_img) {
                this.img_url = url_img;
                this.dialog_zooimg = true;
            },
            startTimer() {
                console.log("focus");
                this.endexamflag = false;
                //myInterval = window.setInterval(timerHandler, 1000);
            },
            stopTimer() {
                console.log("change");
                if (!this.endexamflag) {
                    if (this.TAB_SWITCHING == "NO") {
                        this.tbsnackbar = true;
                        this.tabSwitchCount = this.tabSwitchCount + 1;
                    }

                    this.timeout = 0;
                }
                // window.clearInterval(myInterval);
            },
            onLoad() {
                axios
                    .post("/MockTest/getMockQuestions")
                    .then((res) => {
                        console.log("data:", res.data);
                        if (res.data.msg == "200") {
                            this.que_list = res.data.que_list;
                        }
                    })
                    .catch((error) => {})
                    .finally(() => {});
            },
        },
    };
</script>
<style scoped>
    .log-t {
        background: linear-gradient(130deg, hsla(190, 99%, 30%, 1) 0%, hsla(226, 50%, 65%, 1) 180%);
        color: white;
        padding: 0 !important;
    }
    .log-flex {
        display: flex;
        justify-content: space-between;
        padding: 1rem;
        font-size: 20px;
        color: white;
    }
    .tab-msg {
        padding: 2rem !important;
        font-size: 20px;
    }
    .timer-m {
        display: flex;
    }
    .chat-icon {
        bottom: 0px;
        right: 0px;
        position: fixed !important;

        z-index: 1;
        cursor: pointer;
    }
    .meet-box {
        border: 2px solid #607d8b;
        border-radius: 5px;
        padding: 0.5rem;
    }
    .meet {
        border: 4px solid red;
    }
    .blink_me {
        white-space: nowrap;
        color: red;
        animation: blinker 1s linear infinite;
    }

    @keyframes blinker {
        50% {
            opacity: 0;
        }
    }
    .status {
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 20px;
        margin-top: 0.4rem;
    }
    .v-chip.v-size--default {
        border-radius: 0px !important;
    }
    .pat {
        padding: 17px 46px 17px 46px;
    }
    .end-exam {
        background: red !important;
        color: white;
        font-weight: bold;
        font-size: 16px;
    }
    .timer {
        margin-right: 5px !important;
        color: red;
        font-weight: bold;
        background: #f5f5f5;
        margin: -6px 0px 7px 0px;
        /* border-radius: 30px; */
        padding: 4px 6px 4px 6px;
    }

    .borderes {
        /* border: 1px solid #ff9800;
    background:#ff9800;
    margin: -6px 0px 7px 0px;
    border-radius: 30px;
    padding: 4px 20px 4px 20px; */
        font-size: 16px;
        color: white;
        font-weight: bold;
    }

    .opt {
        background: #607d8b;
        border: 4px solid #a4edf1;
        border-radius: 30px;
        color: white;
        font-size: 16px;
        font-weight: bold;
        margin-top: 0.3%;
        height: 2rem;
        width: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .opt-radio {
        height: 3rem;
        width: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 !important;
    }

    .opt-label {
        margin: 0;
    }

    p {
        display: none !important;
    }

    .question-block {
        /* border: 1.7px solid #424093; */
        margin: 1rem;
        padding-left: 8px;
        border-radius: 6px;
        user-select: none;
    }

    .que-display {
        /* background: #00E5FF !important; */
        /* background-color :#ff4e00;
background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%); */
        background-color: #ffefd5;
        background-image: linear-gradient(315deg, #ffefd5 0%, #fbceb1 74%);

        color: white !important;
        padding: 0.8rem !important;
        /* border: 3px solid #607d8b; */
    }

    .que-tag {
        color: black !important;
        font-size: 18px;
        font-weight: bold;
    }

    .pt {
        padding-top: 70px;
        background: white;
    }

    .heading {
        background: #607d8b !important;
    }

    .sub {
        font-size: 20px;
        font-weight: bold;
    }

    .main-h {
        display: flex;
        justify-content: space-between;
        padding: 0rem 1rem 0rem 1rem;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 1;
        background: #043a56;
    }

    .que {
        /* height: 450px; */
        overflow-y: auto;
    }

    #style-3::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: #f5f5f5;
    }

    #style-3::-webkit-scrollbar {
        width: 4px;
        background-color: #f5f5f5;
    }

    #style-3::-webkit-scrollbar-thumb {
        background-color: #607d8b !important;
    }

    .ans-img {
        width: auto;
        height: 40px;
    }

    .time {
        float: right;
        color: #a4edf1;
        font-size: 18px;
        font-weight: bold;
    }

    .stu-btn {
        width: 40%;
        cursor: none;
        color: white;
        font-weight: bold;
    }

    .nav-btn {
        text-align: center;
        padding: 10px;
    }

    .sub-btn {
        color: white;
        min-width: 10rem !important;
        background: #00e5ff !important;
        font-weight: 500;
        margin: 1rem;
        min-height: 2.5rem;
    }
    .save-btn {
        color: white;
        min-width: 10rem !important;
        background: #f05a2b !important;
        font-weight: 500;
        margin: 1rem;
        min-height: 2.5rem;
    }
    .review-btn {
        color: white;
        min-width: 10rem !important;
        background: blue !important;
        font-weight: 500;
        margin: 1rem;
        min-height: 2.5rem;
    }
    .next-btn {
        color: white;
        min-width: 10rem !important;
        background: #607d8b !important;
        font-weight: 500;
        margin: 1rem;
        min-height: 2.5rem;
    }
    .q-img {
        width: 550px;
        height: auto;
    }

    .new5 {
        border: 2px solid #049bc9;
    }

    @media only screen and (max-width: 600px) {
        .main-h {
            display: block;
            justify-content: space-between;
            padding: 1rem;
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1;
            background: linear-gradient(130deg, hsla(190, 99%, 30%, 1) 0%, hsla(226, 50%, 65%, 1) 180%);
        }

        .row-card {
            margin-top: 10px !important;
            /* display:flex */
        }
        .sub {
            font-size: 15px;
            font-weight: bold;
        }

        .pt {
            background: white;
            padding-top: 120px;
        }

        .sm-pd {
            padding-left: 7px;
        }

        .sub-btn {
            margin: 0.5rem;
        }

        .borderes {
            /* border: 1px solid #ff9800;
    background:#ff9800;
    margin: -6px 0px 7px 0px;
    border-radius: 30px;
    padding: 4px 20px 4px 20px; */
            font-size: 16px;
            color: black;
            font-weight: bold;
            text-align: center;
        }
        .timer-m {
            display: flex;
            justify-content: center;
        }
    }

    .padding-options {
        padding-left: 62px;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }

    .home-icon {
        color: white;
        margin-top: -5px;
    }

    .home-text {
        color: white;
        margin-top: 3px !important;
        font-size: 16px;
        font-weight: bold;
    }

    .card-ques {
        /* padding-left: 13px !important; */
        overflow: scroll;
    }

    .row-card {
        margin-top: -8px;
        /* display:flex */
    }

    .question-text {
        padding: 0px !important;
        margin-left: 19px;
        font-weight: bold;
        user-select: none;
    }

    .options-text {
        font-size: 20px;
        padding-left: 6px;
        margin-left: 1rem;
    }

    .padding-zero {
        padding: 0px !important;
    }
    .padding {
        padding: 0.3rem;
    }
    .padding-top-zero {
        padding-top: 0px !important;
    }

    .option-val {
        opacity: 1;
        margin-top: 10px;
        padding-left: 7px;
    }

    .overview-row {
        padding: 0px;
        padding-top: 12px;
    }

    .overview-card {
        /* height: 504px; */
        overflow-y: scroll;
    }

    .overview-card::-webkit-scrollbar-thumb {
        background-color: #607d8b !important;
    }
    .imgs {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 4px;
        width: 750px;
        cursor: zoom-in;
    }
    .imgs-question {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 4px;
        /* width: 750px; */
        cursor: zoom-in;
        width: 15rem;
        margin-top: 10px;
    }
    .imgs-options {
        /* border: 1px solid #ddd; */
        border-radius: 4px;
        padding: 5px;
        width: auto;
        height: 50px;
        cursor: zoom-in;
    }

    .imgs-preview {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 80%;
    }
    .whiteboard {
        color: white !important;
    }
    .d-f {
        display: flex;
        justify-content: space-between;
    }

    .v-input {
        margin: 0px;
    }
</style>
